import styled from 'styled-components';

const StyledCarsListHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	margin-top: 30px;
`;

const StyledCarsList = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 20px;
	row-gap: 20px;
	width: 100%;
	height: 630px;
	margin-top: 20px;
	overflow: scroll;
	mask-image: linear-gradient(180deg, #ffffff 90%, rgba(255, 255, 255, 0) 100%);

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 20px;
	width: 100%;
	margin-top: 40px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export {
	StyledButtonContent,
	StyledButtonsContainer,
	StyledCarsList,
	StyledCarsListHead,
};
